module.exports = __webpack_public_path__ + "img/Racing Point RP19_car top view_final.57370582.png";